module.exports = __webpack_public_path__ + "img/video-cover-2.36b0a6b7.png";